const fetchReviewers = async (url) => {


    const apiKey = process.env.REACT_APP_API_KEY;  // Access API key from .env
    
    try {
      const response = await fetch(url, {
        headers: {
          'x-api-key': apiKey,  // Use the API key from the environment variable
        },
      });

  
      if (!response.ok) {
        // If the response is not OK, throw an error
        throw new Error(`HTTP error! Status: ${response.status} - ${response.statusText}`);
      }
  
      const data = await response.json();
      return data;
  
    } catch (error) {
      // Log the error message
      console.error('Error fetching reviewers:', error);
  
      // Throw the error so it can be handled by the caller
      throw error;
    }
  };
  
export default fetchReviewers;